(function () {
  "use strict";

  var e = {
    638: function _(e, t, r) {
      var _n,
          o = this && this.__extends || (_n = function n(e, t) {
        return (_n = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
          }
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");

        function r() {
          this.constructor = e;
        }

        _n(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r());
      }),
          i = this && this.__assign || function () {
        return (i = Object.assign || function (e) {
          for (var t, r = 1, n = arguments.length; r < n; r++) {
            for (var o in t = arguments[r]) {
              Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
            }
          }

          return e;
        }).apply(this, arguments);
      },
          s = this && this.__awaiter || function (e, t, r, n) {
        return new (r || (r = Promise))(function (o, i) {
          function s(e) {
            try {
              a(n.next(e));
            } catch (e) {
              i(e);
            }
          }

          function u(e) {
            try {
              a(n.throw(e));
            } catch (e) {
              i(e);
            }
          }

          function a(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
              e(t);
            })).then(s, u);
          }

          a((n = n.apply(e, t || [])).next());
        });
      },
          u = this && this.__generator || function (e, t) {
        var r,
            n,
            o,
            i,
            s = {
          label: 0,
          sent: function sent() {
            if (1 & o[0]) throw o[1];
            return o[1];
          },
          trys: [],
          ops: []
        };
        return i = {
          next: u(0),
          throw: u(1),
          return: u(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;

        function u(i) {
          return function (u) {
            return function (i) {
              if (r) throw new TypeError("Generator is already executing.");

              for (; s;) {
                try {
                  if (r = 1, n && (o = 2 & i[0] ? n.return : i[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, i[1])).done) return o;

                  switch (n = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                    case 0:
                    case 1:
                      o = i;
                      break;

                    case 4:
                      return s.label++, {
                        value: i[1],
                        done: !1
                      };

                    case 5:
                      s.label++, n = i[1], i = [0];
                      continue;

                    case 7:
                      i = s.ops.pop(), s.trys.pop();
                      continue;

                    default:
                      if (!((o = (o = s.trys).length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                        s = 0;
                        continue;
                      }

                      if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                        s.label = i[1];
                        break;
                      }

                      if (6 === i[0] && s.label < o[1]) {
                        s.label = o[1], o = i;
                        break;
                      }

                      if (o && s.label < o[2]) {
                        s.label = o[2], s.ops.push(i);
                        break;
                      }

                      o[2] && s.ops.pop(), s.trys.pop();
                      continue;
                  }

                  i = t.call(e, s);
                } catch (e) {
                  i = [6, e], n = 0;
                } finally {
                  r = o = 0;
                }
              }

              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, u]);
          };
        }
      };

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var a = r(709),
          c = r(356),
          l = r(754),
          h = r(742),
          f = r(463),
          d = r(275),
          p = r(929),
          v = r(804),
          w = p.Debug("ethereum"),
          y = function (e) {
        function t(t, r) {
          var n = e.call(this, {
            network: r
          }) || this;
          return n._ethereumProvider = t, n._network = r, n;
        }

        return o(t, e), t.prototype.request = function (e) {
          for (var t = [], r = 1; r < arguments.length; r++) {
            t[r - 1] = arguments[r];
          }

          return s(this, void 0, void 0, function () {
            var r, n;
            return u(this, function (o) {
              switch (o.label) {
                case 0:
                  return [4, this._ethereumProvider.enable()];

                case 1:
                  o.sent(), o.label = 2;

                case 2:
                  return o.trys.push([2, 4,, 5]), [4, this._ethereumProvider.request({
                    method: e,
                    params: t
                  })];

                case 3:
                  return r = o.sent(), w("got success", r), [2, r];

                case 4:
                  throw n = o.sent(), w("got error", n.message), new l.WalletError(n.toString(), n);

                case 5:
                  return [2];
              }
            });
          });
        }, t.prototype.isWalletAvailable = function () {
          return s(this, void 0, void 0, function () {
            return u(this, function (e) {
              switch (e.label) {
                case 0:
                  return [4, this.request("eth_accounts")];

                case 1:
                  return [2, e.sent().length > 0];
              }
            });
          });
        }, t.prototype.getAddresses = function () {
          return s(this, void 0, void 0, function () {
            var e;
            return u(this, function (t) {
              switch (t.label) {
                case 0:
                  return [4, this.request("eth_accounts")];

                case 1:
                  if (0 === (e = t.sent()).length) throw new l.WalletError("Wallet: No addresses available");
                  return [2, e.map(function (e) {
                    return new d.Address({
                      address: h.remove0x(e)
                    });
                  })];
              }
            });
          });
        }, t.prototype.getUsedAddresses = function () {
          return s(this, void 0, void 0, function () {
            return u(this, function (e) {
              return [2, this.getAddresses()];
            });
          });
        }, t.prototype.getUnusedAddress = function () {
          return s(this, void 0, void 0, function () {
            return u(this, function (e) {
              switch (e.label) {
                case 0:
                  return [4, this.getAddresses()];

                case 1:
                  return [2, e.sent()[0]];
              }
            });
          });
        }, t.prototype.signMessage = function (e) {
          return s(this, void 0, void 0, function () {
            var t, r, n;
            return u(this, function (o) {
              switch (o.label) {
                case 0:
                  return t = Buffer.from(e).toString("hex"), [4, this.getAddresses()];

                case 1:
                  return r = o.sent(), n = r[0], [2, this.request("personal_sign", h.ensure0x(t), h.ensure0x(f.addressToString(n)))];
              }
            });
          });
        }, t.prototype.sendTransaction = function (e) {
          return s(this, void 0, void 0, function () {
            var t, r, n, o, s, a, c;
            return u(this, function (u) {
              switch (u.label) {
                case 0:
                  return [4, this.getWalletNetworkId()];

                case 1:
                  if (t = u.sent(), this._network && t !== this._network.networkId) throw new Error("Invalid Network");
                  return [4, this.getAddresses()];

                case 2:
                  return r = u.sent(), n = f.addressToString(r[0]), o = {
                    from: n,
                    to: e.to ? f.addressToString(e.to) : e.to,
                    value: e.value,
                    data: e.data
                  }, e.fee && (o.gasPrice = new d.BigNumber(e.fee)), [4, h.buildTransaction(o)];

                case 3:
                  return s = u.sent(), [4, this.request("eth_sendTransaction", s)];

                case 4:
                  return a = u.sent(), c = i(i({}, s), {
                    input: s.data,
                    hash: a
                  }), [2, h.normalizeTransactionObject(c)];
              }
            });
          });
        }, t.prototype.canUpdateFee = function () {
          return !1;
        }, t.prototype.getWalletNetworkId = function () {
          return s(this, void 0, void 0, function () {
            var e;
            return u(this, function (t) {
              switch (t.label) {
                case 0:
                  return [4, this.request("net_version")];

                case 1:
                  return e = t.sent(), [2, parseInt(e)];
              }
            });
          });
        }, t.prototype.getConnectedNetwork = function () {
          return s(this, void 0, void 0, function () {
            var e, t;
            return u(this, function (r) {
              switch (r.label) {
                case 0:
                  return [4, this.getWalletNetworkId()];

                case 1:
                  return e = r.sent(), t = v.findKey(c.EthereumNetworks, function (t) {
                    return t.networkId === e;
                  }), e && !t ? [2, {
                    name: "unknown",
                    networkId: e
                  }] : [2, c.EthereumNetworks[t]];
              }
            });
          });
        }, t;
      }(a.WalletProvider);

      t.default = y;
    },
    175: function _(e, t, r) {
      var n = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.EthereumWalletApiProvider = void 0;
      var o = n(r(638));
      t.EthereumWalletApiProvider = o.default;
    },
    929: function _(e) {
      e.exports = require("@liquality/debug");
    },
    754: function _(e) {
      e.exports = require("@liquality/errors");
    },
    356: function _(e) {
      e.exports = require("@liquality/ethereum-networks");
    },
    742: function _(e) {
      e.exports = require("@liquality/ethereum-utils");
    },
    275: function _(e) {
      e.exports = require("@liquality/types");
    },
    463: function _(e) {
      e.exports = require("@liquality/utils");
    },
    709: function _(e) {
      e.exports = require("@liquality/wallet-provider");
    },
    804: function _(e) {
      e.exports = require("lodash");
    }
  },
      t = {},
      r = function r(n) {
    var o = t[n];
    if (void 0 !== o) return o.exports;
    var i = t[n] = {
      exports: {}
    };
    return e[n].call(i.exports, i, i.exports, r), i.exports;
  }(175);

  module.exports = r;
})();